import { format } from 'date-fns';
import { getUTCDate } from './helpers';
import {
  ClientWarehouse,
  ClientWarehouseBE,
  CountryThreshold,
  SellerFilingReport,
  SellerFilingReportToConfirm,
} from './types';

export const normalizeCountryThresholdFE = (item: CountryThreshold) => ({
  ...item,
  threshold: {
    ...item.threshold,
    value: item.threshold.value / 100,
  },
});
export const normalizeClientWarehousesFE = (
  item: ClientWarehouseBE
): ClientWarehouse => ({
  ...item,
  active_from: new Date(item.active_from),
});
export const normalizeDateBE = (date: Date) =>
  format(date, "yyyy-MM-dd'T'HH:mm:ss+00:00");

export const normalizeDateFE = (iso: string) => {
  return getUTCDate(new Date(iso));
};

export const normalizeFilingReport =
  (completed_filing: boolean) =>
  (r: SellerFilingReport): SellerFilingReportToConfirm => {
    return {
      ...r,
      completed_filing,
    };
  };
